const TABLE_STYLES = {
    filtersGrid: [
      'w-full',
      'grid',
      'grid-cols-1',
      'min-w-96',
      'mb-2',
      'gap-2',
      'xl:gap-4',
      'px-6',
      'py-2',
      'bg-gray-300',
      'box-border',
      'min-w-0',
    ].join(' '),
  filtersCust: ['xl:grid-cols-[264px_1fr_650px]'].join(' '),
  filtersOpp: [
    'md:grid-cols-[1fr_142px]',
    'xl:grid-cols-[264px_minmax(142px,1fr)_870px]',
  ].join(' '),
  pagination: ['bg-gray-300', 'px-6', 'box-border', 'w-full', 'min-w-0'].join(' '),
};

export default TABLE_STYLES;
